export default "__VITE_ASSET__Csa0xpDM__"